import { useParams } from 'react-router-dom'
import CleanEnergyTechnologiesArticleSource from './technologiesArticleSource'

export default function CleanEnergyMineralsTechnologiesWindEnergyArticle() {
  const { lng } = useParams()
  if (lng === 'en')
    return (
      <>
        <article className="mb-8">
          <div className="mb-8">
            <img
              src="/assets/images/technologies/wind-energy/wind-energy-banner.webp"
              alt="Wind energy banner showing wind turbines generating electricity"
              className="h-[412px] w-full object-cover"
              itemprop="image"
            />
          </div>
          <h1 className="mb-4 text-2xl font-bold">Wind Energy</h1>
          <p className={`mb-16`}>
            Wind energy is a type of renewable energy that uses the movement of wind to generate electricity, by converting the rotational motion of wind devices, such as wind turbines, into electrical energy using electric generators.
            <br />
            Wind turbines require many Minerals like copper, zinc, manganese, nickel, and chromium, in addition to rare earth elements, which play a vital role in constructing these turbines that rely on permanent magnets.
          </p>
          <h2 className="mb-4 text-2xl font-bold">Minerals used in Wind Energy</h2>
          <div className="mb-16 flex justify-center">
            <img
              src="/assets/images/technologies/wind-energy/wind-energy-compound-en.webp"
              alt="Minerals used in wind energy"
              className="max-h-[512px] w-full object-contain"
            />
          </div>
          <h2 className="mb-4 text-2xl font-bold">Global Demand for Minerals used in Wind Energy</h2>
          <iframe
            title="Global demand for Minerals used in wind energy"
            className="h-96 w-full border-2 border-muted-300 md:h-[600px] lg:h-[650px] xl:h-[728px]"
            src="https://app.powerbi.com/view?r=eyJrIjoiZmM4MDQ4OWEtODkzNS00MGQ5LWExNTMtZTFjYTBhNDhiODhhIiwidCI6IjYwMDgzM2ZiLTcyZTEtNDJhOS1iMTUwLTI5NzJmYzc5MDMwYSJ9"
          />
        </article>
        <CleanEnergyTechnologiesArticleSource
          language="en"
          label="International Energy Agency 2025"
          link={`https://www.iea.org/`}
          target="_blank"
        />
      </>
    )
  if (lng === 'ar')
    return (
      <>
        <article className="mb-8">
          <div className="mb-8">
            <img
              src="/assets/images/technologies/wind-energy/wind-energy-banner.webp"
              alt="لافتة طاقة الرياح تظهر توربينات الرياح التي تولد الكهرباء"
              className="h-[412px] w-full object-cover"
              itemprop="image"
            />
          </div>
          <h1 className="mb-4 text-2xl font-bold">طاقة الرياح</h1>
          <p className={`mb-16`}>
            طاقة الرياح هي نوع من الطاقة المتجددة تستخدم حركة الرياح لتوليد الكهرباء، من خلال تحويل الحركة الدورانية لأجهزة الرياح، مثل التوربينات الهوائية، إلى طاقة كهربائية باستخدام مولدات كهربائية.
            <br />
            تتطلب توربينات الرياح العديد من المعادن مثل النحاس، الزنك، المنجنيز، النيكل والكروم بالإضافة الى العناصر الأرضية النادرة التي تلعب دورًا حيويًا في بناء هذه التوربينات التي تعتمد على المغناطيس الدائم.
          </p>
          <h2 className="mb-4 text-2xl font-bold">المعادن المستخدمة في طاقة الرياح</h2>
          <div className="mb-16 flex justify-center">
            <img
              src="/assets/images/technologies/wind-energy/wind-energy-compound-ar.webp"
              alt="معادن طاقة الرياح"
              className="max-h-[512px] w-full object-contain"
            />
          </div>
          <h2 className="mb-4 text-2xl font-bold">الطلب العالمي على المعادن المستخدمة في طاقة الرياح</h2>
          <iframe
            className="h-96 w-full border-2 border-muted-300 md:h-[600px] lg:h-[650px] xl:h-[728px]"
            title="الطلب العالمي على المعادن المستخدمة في طاقة الرياح"
            src="https://app.powerbi.com/view?r=eyJrIjoiNTI0ZTAxZjctMjJlOS00ZGUzLWExNWItNTM5ZjFmNTA5OWYxIiwidCI6IjYwMDgzM2ZiLTcyZTEtNDJhOS1iMTUwLTI5NzJmYzc5MDMwYSJ9"
          />
        </article>
        <CleanEnergyTechnologiesArticleSource
          language="ar"
          label={` وكالة الطاقة الدولية 2025`}
          link={`https://www.iea.org/`}
          target="_blank"
        />
      </>
    )
}
